import React from "react";
import { NoDataAvailableDiv } from "../components/NoDataAvailableDiv";
import ProductsTable from "./ProductsTable";
import SectionPanel from "components/panels/SectionPanel/SectionPanel";
import PanelSegment from "components/panels/PanelSegment/PanelSegment";

interface Props {
  productsPanel: server.dto.ProductsPanel
  startUncollapsed?: boolean
}

const ReadonlyProductsPanelSegment = (props: Props) => {
  return <SectionPanel.Panel
    header={<>
      <PanelSegment.Title title={RESX.Product.Products} />
    </>}
    collapsible={{
      persist: false,
      start: props.startUncollapsed ? "open" : "closed",
      uniqueRowId: "esignReadonlyProductsPanel"
    }}
  >
    {props.productsPanel.data.collection.length > 0 && <ProductsTable
      onEditClicked={() => { /* */ }}
      onDeleteClicked={() => { /* */ }}
      onCopyClicked={() => { /* */ }}
      productsByParent={props.productsPanel.data}
      productsPanelConfig={props.productsPanel.config}
      onProductsOrderChanged={() => { /* */ }}
      disabled
    />}
    {props.productsPanel.data.collection.length === 0 && <NoDataAvailableDiv />}
  </SectionPanel.Panel>;
};

export default ReadonlyProductsPanelSegment;